export enum Title {
  DEFAULT = '카카오 바이크 운영',
  MEMBER_WORK_STATUS = '멤버별 작업 현황',
  MY_WORK_STATUS = '내 작업 현황',
  SEARCH = '검색',
  FUSHIDA_DISCONNECT_ERROR = '후시다 기기 연결해제 에러',
}

export enum LeftType {
  DEFAULT = 'default',
  BACK = 'back',
}
